<!-- 财务转账列表 -->
<template>
  <div class="transfer-list-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-input
        size="small"
        clearable
        placeholder="流水id"
        v-model="params.id"
        @change="getTransferList('status')"
        class="param-input"
      />
      <el-select
        v-model="params.status"
        size="small"
        placeholder="选择状态"
        clearable
        @change="getTransferList('status')"
      >
        <el-option
          v-for="item in statusList"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="time"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>
      <el-button type="primary" size="small" @click="getTransferList('status')">搜索</el-button>
    </div>
    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
    >
      <el-table-column prop="id" label="流水id" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userID" label="用户ID" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.userID || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="withdrawCent" label="提现金额(元)" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.withdrawCent || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="taxCent" label="税金(元)" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.taxCent || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="afterTaxCent" label="税后提现金额(元)" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.afterTaxCent || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" align="center" min-width="260">
        <template slot-scope="scope">
          <span>{{ scope.row.desc || "无" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.remark || "无" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.status | trsndferStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="payMentMethod" label="付款方式" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.payMentMethod || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="act" label="付款账号" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.act || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="actName" label="付款姓名" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.actName || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="申请时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="failureAt" label="失败时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.failureAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="successAt" label="成功时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.successAt | changeDate }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" fixed="right" min-width="250">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="转账成功,结束转账"
            placement="top"
            v-if="scope.row.status === 1"
          >
            <el-button type="success" size="mini" @click="openDialog(scope.row.id)">转账成功</el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="退还转账金额"
            placement="top"
            v-if="scope.row.status === 1"
          >
            <el-button type="danger" size="mini" @click="openDialog1(scope.row.id)">转账失败</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[5, 10, 15, 20]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!---->
    <el-dialog
      :title="'账单回执'"
      :visible.sync="dialogVisible"
      width="500px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="eParams.remark"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="toExamine()" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import {changeTime} from "@/utils/global";

export default {
  data() {
    return {
      time: "",
      flag: false,
      dialogVisible: false,
      total: 0,
      list: [],
      tableData: [],
      //请求列表参数
      params: {
        pageNumber: 1, //[必传]
        pageSize: 20, //[必传]
        startTime: "", //开始时间
        endTime: "", //结束时间
        status: "", //状态 1:转账中 2：转账成功 3：转账失败
        id: "", //ID
      },
      statusList: [
        { label: "转账中", value: "1" },
        { label: "转账成功", value: "2" },
        { label: "转账失败", value: "3" },
      ],
      // 审核接口参数
      eParams: {
        id: "",
        transState: "",
        remark: "",
      },
    };
  },
  created() {
    this.getTransferList();
  },
  methods: {
    // 请求财务转账列表
    getTransferList() {
      this.loading = true;
      API.getTransferList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.total = res.data.total;
            this.tableData = res.data.list;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || "";
        this.params.endTime = changeTime(time[1]) || "";
      } else {
        this.params.startTime = "";
        this.params.endTime = "";
      }
      this.getTransferList("status");
    },
    // 弹窗关闭
    handleClose() {
      this.dialogVisible = false;
      this.transState = "";
    },
    openDialog(id) {
      this.dialogVisible = true;
      this.eParams.id = id;
      this.eParams.transState = 1;
      this.eParams.remark = "";
    },
    openDialog1(id) {
      this.dialogVisible = true;
      this.eParams.id = id;
      this.eParams.transState = 2;
      this.eParams.remark = "";
    },
    toExamine() {
      // eslint-disable-next-line no-unused-vars
      API.receipt(this.eParams).then((res) => {
        if (this.eParams.transState === 1) {
          this.$message({
            message: "转账成功！",
            type: "success",
          });
        }
        if (this.eParams.transState === 2) {
          this.$message.error({
            message: "转账失败！",
          });
        }
        this.handleClose();
        this.getTransferList();
      });
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getTransferList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getTransferList();
    },
  },
};
</script>

<style lang="" scoped></style>
